<template>
  <button
    class="inline-flex justify-center p-2 md:p-1 md:pr-2 text-sm font-medium text-blue-900 bg-blue-50 bg-transparent border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
    type="button"
  >
    <i-heroicons-outline-plus-circle class="mx-1 mt-0.5" />
    <slot></slot>
  </button>
</template>
